/*
 * @Description:
 * @Author: gq
 * @Date: 2021-09-03 10:25:57
 * @LastEditors: guqiang
 * @LastEditTime: 2021-09-08 13:51:06
 */
import request from './request';

// 补贴申请列表(done)
export function getSubsidyApplys(params) {
    return request('/equity/subsidy/list', {
        method: 'POST',
        params,
    });
}

// 补贴申请详情
export function getSubsidyApply(id) {
    return request(`/equity/subsidy/detail/${id}`, {
        method: 'GET',
    });
}

// 补贴申请到店核销
export function putCheck(params) {
    return request('/equity/subsidy/check', {
        method: 'PUT',
        params,
        headers: {
            'Cancel-Message': true,
        },
    });
}

// 是否可以申请代步补贴
export function travelapply(params) {
    return request('subsidy/travel/apply/check', {
        method: 'GET',
        params,
        headers: {
            'Cancel-Message': true,
        },
    });
}

// 补贴申请提交维修资料
export function postRepairInfo(id, params) {
    return request(`/equity/subsidy/info/${id}`, {
        method: 'POST',
        params,
    });
}

// 暂存补贴申请维修资料
export function statingRepairInfo(id, params) {
    return request(`/equity/subsidy/info/${id}/stash`, {
        method: 'POST',
        params,
    });
}

// 补贴申请获取维修资料
export function getRepairInfo(id) {
    return request(`/equity/subsidy/info/${id}`, {
        method: 'GET',
    });
}

// 补贴申请操作记录
export function getSubsidyOplog(id, params) {
    return request(`/equity/subsidy/${id}/oplog`, {
        method: 'GET',
        params,
    });
}


// 计算补贴金额
export function calsSubsidyAmount(id, subsidyDays) {
    return request(`/subsidy/travel/calc/${id}/${subsidyDays}`, {
        method: 'GET',
    });
}

// 查询银行账号
export function getFinanceAccount() {
    return request('/equity/subsidy/finance/account', {
        method: 'GET',
    });
}
